// import apiClient from '../../../apis/portali';
import apiClient from '../../../apis/portaliref';
import { portaleApi } from '../../../helpers/portaleModuleHelper';

const api = portaleApi('galleria', apiClient, {
// const api = portaleApi('photoGalleries', apiClient, {
    // top: 'perPage',
    per_page: 'perPage',
    page: 'page',
    nome: 'q',
    orderby: 'orderKey',
    orderdir: 'orderDirection',
    anagrafica_id:'ao_hotel_id',
    ao_hotel_id: 'ao_hotel_id',
});

api.UpdateFoto = (galleryId, foto, nome) => {
    return apiClient({
        url: `galleria/${galleryId}`,
        method: 'patch',
        data: {
            foto,
            nome
        }
    });
};

export default api;
